import { Timestamp } from 'firebase/firestore';

/**
 * Represents a disabled time slot in Firestore
 * Document ID format: YYYY-MM-DD_HH:MM_AM/PM
 * Example: 2024-12-20_09:00_AM
 */
export interface DisabledSlot {
  date: string; // YYYY-MM-DD format
  time: string; // HH:MM AM/PM format (e.g., "9:00 AM")
  disabledAt: Timestamp;
  disabledBy: string; // admin username or "system"
  reason?: string;
}

/**
 * Format a slot identifier for Firestore document ID
 */
export function formatSlotId(date: string, time: string): string {
  // Remove spaces and colons for clean document ID
  // Example: "2024-12-20" + "9:00 AM" -> "2024-12-20_09:00_AM"
  return `${date}_${time.replace(/:/g, ':').replace(/ /g, '_')}`;
}

/**
 * Parse a slot ID back to date and time
 */
export function parseSlotId(slotId: string): { date: string; time: string } {
  const parts = slotId.split('_');
  const date = parts[0];
  const time = `${parts[1]} ${parts[2]}`;
  return { date, time };
}
